import { createContext } from 'react';
import { IRestaurantDevices, IAssignDevices } from 'types';

export type TAssignDevicesSortBy = '' | 'HardwareIdA-Z' | 'HardwareIdZ-A' | 'TerminalId1-10' | 'TerminalId10-1';
export type TAssignDevicesCountOfItems = '12' | '24' | '48';
export type TTypeOfModalWindow = null | 'toConfirmFieldsClearing' | 'toConfirmSubmit' | 'success' | 'error';

export interface IAssignDevicesState {
	restaurantDevices: IRestaurantDevices;
	searchString: string;
	showFreeDevices: boolean;
	sortBy: TAssignDevicesSortBy;
	countOfItems: TAssignDevicesCountOfItems;
	currentPage: number;
	dataForAssign: IAssignDevices | null;
	typeOfModalWindow: TTypeOfModalWindow;
}

export const assignDevicesInitialState: IAssignDevicesState = {
	restaurantDevices: { count: 0, items: [] },
	searchString: '',
	showFreeDevices: false,
	sortBy: '',
	countOfItems: '12',
	currentPage: 1,
	dataForAssign: null,
	typeOfModalWindow: null,
};

export interface IAssignDevicesContext extends IAssignDevicesState {
	changeSearchString(value: string): void;
	toggleSetShowFreeDevices(): void;
	setSortBy(sortBy: TAssignDevicesSortBy): void;
	setCountOfItems(count: TAssignDevicesCountOfItems): void;
	changeCurrentPage(page: number): void;
	toggleDeviceAssignedStatus(deviceId: string, status: boolean): void;
	toggleSelectAllDevices(value: boolean): void;
	setDataForAssign(data: IAssignDevices): void;
	changeTypeOfModalWindow(value: TTypeOfModalWindow): void;
}

export const AssignDevicesContext = createContext<IAssignDevicesContext>({
	changeSearchString: () => undefined,
	toggleSetShowFreeDevices: () => undefined,
	setSortBy: () => undefined,
	setCountOfItems: () => undefined,
	changeCurrentPage: () => undefined,
	toggleDeviceAssignedStatus: () => undefined,
	toggleSelectAllDevices: () => undefined,
	setDataForAssign: () => undefined,
	changeTypeOfModalWindow: () => undefined,
	...assignDevicesInitialState,
});
